import { makeStyles, Typography, IconButton } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  assignmentContainer: {
    borderRadius: "10px",
    backgroundColor: theme.palette.common.white,
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1.5),
    display: "flex",
    alignItems: "flex-start", // so multi-line title aligns properly
    justifyContent: "space-between",
    gap: theme.spacing(1),
  },
  countNumber: {
    backgroundColor: theme.palette.background.paper,
    width: 36,
    height: 36,
    textAlign: "center",
    lineHeight: "36px",
    borderRadius: theme.shape.borderRadius,
    fontWeight: "bold",
    flexShrink: 0,
  },
  titleWrap: {
    flexGrow: 1,
    minWidth: 0,
    cursor: "pointer",
    wordBreak: "break-word", // wrap long words
    whiteSpace: "normal", // allow wrapping
    "&:hover": {
      textDecoration: "underline",
    },
  },
  childCss: {
    display: "flex",
    flexShrink: 0,
    gap: theme.spacing(1),
  },
}));

const CustomListItem = ({ title = "", children, count, onOpenPDF }) => {
  const classes = useStyles();
  const handleClick = () => {
    if (typeof onOpenPDF === "function") {
      try {
        onOpenPDF();
      } catch (err) {
        console.error("Error opening PDF:", err);
      }
    } else {
      console.warn("No PDF handler provided");
    }
  };
  return (
    <div className={classes.assignmentContainer}>
      {/* Left: Count */}
      <Typography className={classes.countNumber} color="textSecondary">
        {count}
      </Typography>

      {/* Middle: Title (multi-line clickable) */}
      <Typography
        variant="subtitle1"
        className={classes.titleWrap}
        onClick={handleClick}
      >
        {decodeURI(title)}
      </Typography>

      {/* Right: Action icons */}
      <div className={classes.childCss}>{children}</div>
    </div>
  );
};

export default CustomListItem;
